import { CompactUserResponse, UserId, VeryCompactUserResponse } from '../account';
import { TeamId } from '../team';

export type ClockinID = string;

export interface ClockinResponse {
  id: ClockinID;
  status: ClockInStatus;
  time: number;
  createdAt: number;
  forDate: number;
  notes: string;
  user: CompactUserResponse;
}
export interface ClockinReportResponse {
  id: ClockinID;
  status: ClockInStatus;
  time: string;
  startedAt: string;
  stoppedAt: string;
  forDate: number;
  notes: string;
  user: CompactUserResponse;
  isManual: boolean;
  history: ClockinHistoryResponse[];
}

export interface ClockinHistoryResponse {
  id: string;
  log: string;
  user: CompactUserResponse;
  type: ClockinHistoryType;
  clockinId: ClockinID;
  createdAt: number;
}

export enum ClockinHistoryType {
  created = 'created',
  updated = 'updated',
  deleted = 'deleted',
  stopped = 'stopped',
}

export enum ClockInStatus {
  started = 'started',
  completed = 'completed',
}

export interface ClockinPageQuery {
  dateRange?: string;
  users?: UserId[];
  teams?: TeamId[];
  requestId?: number;
}

export interface UserClockReportQuery {
  dateRange?: string;
}

export interface UserClockReportResponse {
  date: string;
  clockins: ClockinReportResponse[];
}

export type ClockinReportData = { [key: string]: string | number | boolean | null | undefined };

export interface ClockinManualResponse {
  tracker: ClockinResponse;
  message: string;
}

export interface TeamClockinResponse {
  startDate: number;
  endDate: number;
  report: ClockinTimesheetResponse[];
}

export interface ClockinTimesheetResponse {
  timeString: string;
  timeInSeconds: number;
  user: VeryCompactUserResponse;
  maximumHours: number;
  allowOvertime: boolean;
  ovetimeHours: number;
  hasSurpassedTotalTime: boolean;
  totalTimeAllowed: number;
  days: ClockinTimesheetDays[];
}

export interface ClockinTimesheetDays {
  date: string;
  timeInSeconds: number;
  time: string;
}
